module.exports = __webpack_public_path__ + "img/skating001.a007b2b0.jpg";